export default __webpack_public_path__ + "static/PromptIconEleven-414c3e27897b8f30882de088de155733.png";